import { Component, OnDestroy, AfterViewInit, NgZone, Inject  } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JssContextService } from './jss-context.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy, AfterViewInit {
  private contextSubscription: Subscription;

  constructor(
    translate: TranslateService,
    jssContextService: JssContextService,
    private router: Router,
    private ngZone: NgZone,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.contextSubscription = jssContextService.state.subscribe(jssState => {
      // listen for language changes
      if (jssState.language) {
        translate.use(jssState.language);
      }
    });
  }

  ngAfterViewInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const tree = this.router.parseUrl(this.router.url);
      if (tree.fragment) {
        this.ngZone.onStable.pipe(take(1)).subscribe(() => {
           requestAnimationFrame(() => {
             setTimeout(() => {
               const element = this.document.getElementById(tree.fragment!);
               if (element) {
                 element.scrollIntoView({ behavior: 'auto', block: 'center' });
               }
             }, 500); // small delay helps for components still rendering
           });
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }
}
